import { ButtonLink } from "@/components/button-link";
import { Page } from "@/components/page";
import { Center, Stack, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_landing/payment-successful")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page title="Payment Success">
      <Stack mt="xl">
        <Title ta="center" c="green">
          Thank you!
        </Title>
        <Text ta="center">Your payment was successful.</Text>
        <Center mt="md">
          <ButtonLink to="/home">Click here to continue</ButtonLink>
        </Center>
      </Stack>
    </Page>
  );
}
